import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { PlatformLocation} from '@angular/common';
@Component({
  selector: 'app-mz-button-img',
  templateUrl: './mz-button-img.component.html',
  styleUrls: ['./mz-button-img.component.scss']
})
export class MzButtonImgComponent extends GridBaseCase {

  constructor(
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private platformlocation:PlatformLocation
  ) { super(); }

  ngOnInit() {
  }
  getAction(url) {
    const that=this;
    // if(that.platformlocation["location"].hash.replace('#','')){
    //   localStorage.setItem("backurl",that.platformlocation["location"].hash.replace('#',''));
    // }
    if(url){
      // this.router.navigateByUrl(url);
      if (url.indexOf("http") > 0) {
        if(this.element.elementInfo.title){
          this.com.goWebPage(url,this.element.elementInfo.title);
        }else{

        }
      } else {
        that.com.setHistoryUrl();
        if(url.split('/').length==4 || url.split('/').length==5){
          // that.router.navigateByUrl(url+"/"+that.com.getNowDatetime);
          that.com.Go(url+"/"+that.com.getNowDatetime);

        }else if(url.split('/').length==6){
          if(url.indexOf('&')=="-1"){
            // that.router.navigate([url+'&'+that.com.getNowDatetime]);
            that.com.Go(url+'&'+that.com.getNowDatetime);
          }else{
            // that.router.navigate([url+that.com.getNowDatetime]);
            that.com.Go(url+that.com.getNowDatetime);
          }
        }else{
          // that.router.navigateByUrl(url);
          that.com.Go(url);
        }
      } 
    }else{
      this.msg.Show("暂未开通","middle");
    }
  }
}
